export default __webpack_public_path__ + "static/media/MargaritaPizza.4453675b.jpg";